module.exports = __webpack_public_path__ + "static/media/smoldering_volcanoe.a3267d95.png";